export const AggsTypes = {
  EMOTIONS: "emotions",
  MIME_TYPES: "mime_types",
  OBJECTS: "objects",
  SOURCES: "sources",
  TAGS: "tags"
};
